import * as types from '../../action-types';
import {getSingleUpload as initialState } from "../../initialState";

const getSingleUpload = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_UPLOAD_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_UPLOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_UPLOAD_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleUpload;
